import { MortgageRates } from '../../interfaces/mortgages';
import { IGlobalState } from '../index';

export const mortgagesSelector = (state: IGlobalState): MortgageRates => state.mortgages;
